import axios from 'axios';

import { getAuthSession } from '@/auth/session';
import { clearImpTokens, clearSessionRole, isImpersonating } from '@/auth/tabStorage';

import * as auth from './../utils/auth';
import Api from './api';

export default (services, { app }) => {
  const api = {};
  api.registry = [];
  api.isRefreshing = false;
  api.refreshRequest = null;
  api.queue = [];

  api.updateCredentials = ({ token, refreshToken, email }) => {
    // Must run before setTokens: AuthSession keys storage by current-user.
    auth.saveUser({ email });
    getAuthSession().setTokens({ accessToken: token, refreshToken });
  };

  api.logout = () => {
    const fakeLogin = auth.readFakeLogin();
    if (isImpersonating() && fakeLogin.admin) {
      // Sign out from impersonation means signing out the real admin session.
      auth.saveUser({ email: fakeLogin.admin });
    }
    clearImpTokens();
    clearSessionRole();
    auth.saveFakeLogin();
    getAuthSession().logout();
    auth.deleteUser();
    auth.deleteActiveRole();

    api.registry.forEach((name) => {
      api[name].logout();
    });
    window.location.href = '/login';
  };

  api.client = axios;

  services.forEach((service) => {
    api.registry.push(service.name);
    const options = {
      baseUrl: service.baseUrl,
      authRequired: Object.prototype.hasOwnProperty.call(service, 'authRequired') ? service.authRequired : false,
      apiRef: api, // Pass api reference for interceptors
    };
    if (service.lang) {
      options.lang = true;
    }
    if (service.role) {
      options.role = true;
    }
    api[service.name] = new Api(options);
  });

  app.config.globalProperties.$api = api;
  app.provide('api', api);

  if (typeof window !== 'undefined') {
    window.__API__ = api;
  }

  return api;
};
